/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import AuthDetailsContainer from './auth-details/AuthDetails.container';
import UserCreateContainer from './user-create/UserCreate.container';
import UserDetailsContainer from './user-details/UserDetails.container';
import Users from './user-list/UserList.container';
import { NotFoundErrorView } from '../error/ErrorPages.view';
import { PlatformAdminUIState } from '../../store/store';
import { connect } from 'react-redux';

export const USERS_URL = '/users';
export const USERS_CREATE_URL = USERS_URL + '/create';
const USERS_DETAILS_URL_BASE = USERS_URL + '/details/:id';
const USERS_AUTH_DETAILS_URL_BASE = USERS_URL + '/auth/:email';
const USERS_PROFILE_URL = USERS_URL + '/profile';

export function getUsersDetailsUrl(userId: string): string {
	return USERS_DETAILS_URL_BASE.replace(':id', userId);
}

export function getUsersAuthDetailsUrl(email: string): string {
	return USERS_AUTH_DETAILS_URL_BASE.replace(':email', email);
}

interface Props extends RouteComponentProps {
	currentUserId: string | undefined;
}

class UsersRoutingContainer extends React.Component<Props> {
	render(): JSX.Element {
		const {
			currentUserId,
			match: { url }
		} = this.props;

		return (
			<Switch>
				<Route exact path={url} component={Users} />
				<Route path={USERS_CREATE_URL} component={UserCreateContainer} />
				<Redirect from={USERS_PROFILE_URL} to={getUsersDetailsUrl(currentUserId || '') + '?profile'} />
				<Route path={USERS_DETAILS_URL_BASE} component={UserDetailsContainer} />
				<Route path={USERS_AUTH_DETAILS_URL_BASE} component={AuthDetailsContainer} />
				<Route component={NotFoundErrorView} />
			</Switch>
		);
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: PlatformAdminUIState) => {
	return {
		currentUserId: state.global.person?.id
	};
};

export default withRouter(connect(mapStateToProps)(UsersRoutingContainer));
